import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://supabase.seryiads.com';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzdXBhYmFzZSIsImlhdCI6MTc4NDQwNDI2MCwiZXhwIjo0OTQwMDc3ODYwLCJyb2xlIjoiYW5vbiJ9.9jKuDEwP7J946tdGXNZMnlZ49UzrhXrPOjZLakt70iI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
